import { useCallback } from 'react';
import { useMessagePort } from 'providers/message-channel';

/**
 * Custom hook for Fujifilm navigation via postMessage.
 * Returns the message port and a function to send navigation messages.
 */
const usePostMessage = () => {
  const { sendToHost } = useMessagePort();

  const postMessageNav = useCallback((path: string) => {
    sendToHost({ type: 'fujifilmNavigation', payload: { path } });
  }, []);

  return { postMessageNav };
};

export default usePostMessage;
